export type AttributeListPagingDataType = { id: string; totalCount: number | null; pageIndex: number; pageSize: number };
